import React, { Component } from 'react'
import './index.scss'
import { Tabs } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'

export class index extends Component {
  state = {}
  componentWillMount() {}

  render() {
    return (
      <div className="mytypeARVR ARVR">
        <div className="ARVR-title">
          <div className="ARVR-title-h1">应用案例</div>
          <div className="ARVR-title-text">APPLICATION CASES</div>
        </div>
        <div className="ARVR-content">
          <div className="ARVR-content-item jiaotong" style={{ backgroundImage: `url(${require('../../../image/智慧交通.png')})` }}>
            {/* <div className="ARVR-content-item jiaotong" style={{ flex: 2, backgroundImage: `url(${require('../../../image/应用案例-交通.jpg')})` }}> */}
            <img className="ARVR-content-item-img jiaotong-content" src={require('../../../image/icon交通.png')} alt="" />
            <div className="ARVR-content-item-title jiaotong-content">智慧交通</div>
            <div className="ARVR-content-item-content jiaotong-content">
              交通运输 <br />
              公众出行
              <br /> 智能管理
            </div>
          </div>
          <div className="ARVR-content-item yuanqu" style={{ backgroundImage: `url(${require('../../../image/智慧园区.png')})` }}>
            <img className="ARVR-content-item-img yuanqu-content" src={require('../../../image/icon园区.png')} alt="" />
            <div className="ARVR-content-item-title yuanqu-content">智慧园区</div>
            <div className="ARVR-content-item-content yuanqu-content">
              电梯控制
              <br />
              访客登记
              <br />
              电子巡更
              <br />
              资产管理
            </div>
          </div>
          <div className="ARVR-content-item gongchang" style={{ backgroundImage: `url(${require('../../../image/智慧园区.png')})` }}>
            <img className="ARVR-content-item-img  gongchang-content" src={require('../../../image/icon工厂.png')} alt="" />
            <div className="ARVR-content-item-title gongchang-content">智慧工厂</div>
            <div className="ARVR-content-item-content gongchang-content">
              旅游服务 <br />
              旅游管理 <br /> 旅游营销 <br /> 旅游体验
            </div>
          </div>
          <div className="ARVR-content-item wenlv" style={{ backgroundImage: `url(${require('../../../image/智慧文旅.png')})` }}>
            <img className="ARVR-content-item-img wenlv-content" src={require('../../../image/icon文旅.png')} alt="" />
            <div className="ARVR-content-item-title wenlv-content">智慧文旅</div>
            <div className="ARVR-content-item-content wenlv-content">
              旅游服务 <br />
              旅游管理 <br /> 旅游营销 <br /> 旅游体验
            </div>
          </div>
          <div className="ARVR-content-item shuiwu" style={{ backgroundImage: `url(${require('../../../image/智慧水务.png')})` }}>
            <img className="ARVR-content-item-img shuiwu-content" src={require('../../../image/icon智慧水务.png')} alt="" />
            <div className="ARVR-content-item-title shuiwu-content">智慧水务</div>
            <div className="ARVR-content-item-content shuiwu-content">
              饮水安全监测
              <br /> 水文监测及预警
              <br /> 污水处理排放
              <br /> 地下水监测
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default index
